import { render, staticRenderFns } from "./DailyTaskConfig.vue?vue&type=template&id=5ad4cb68"
import script from "./DailyTaskConfig.vue?vue&type=script&lang=js"
export * from "./DailyTaskConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports